import { __awaiter, __generator } from "tslib";
import { networkRequest } from '@tencent/ark-request';
import { LoggerProxy } from '../logger/logger-proxy';
// 拉取文档内资源（含图片和附件）信息的 CGI
var documentResourceFetchUrl = '/api/onlinedocs/fetchresource';
// 前端自定义无效值
export var invalidRetCode = Number.MAX_SAFE_INTEGER;
var DocumentResourceFetcher = /** @class */ (function () {
    function DocumentResourceFetcher() {
        Object.defineProperty(this, "tag", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'DocumentResourceFetcher'
        });
    }
    Object.defineProperty(DocumentResourceFetcher.prototype, "fetDocumentResourceFromServer", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (globalPadId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, status, statusText;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = this.buildfetchDocumentResourceURL(globalPadId);
                            return [4 /*yield*/, networkRequest.get(url)];
                        case 1:
                            response = _a.sent();
                            status = response.status, statusText = response.statusText;
                            if (status !== 200) {
                                return [2 /*return*/, {
                                        retcode: invalidRetCode,
                                        msg: statusText,
                                    }];
                            }
                            return [2 /*return*/, this.convertResponseToReourceData(response.data)];
                    }
                });
            });
        }
    });
    Object.defineProperty(DocumentResourceFetcher.prototype, "buildfetchDocumentResourceURL", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (globalPadId) {
            LoggerProxy.info(this.tag, '生成拉取文档资源信息 CGI 请求 URL, globalPadId: ', globalPadId);
            var searchParams = new URLSearchParams();
            searchParams.set('pad_id', "".concat(globalPadId));
            return "".concat(documentResourceFetchUrl, "?").concat(searchParams.toString());
        }
    });
    Object.defineProperty(DocumentResourceFetcher.prototype, "convertResponseToReourceData", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            var _a;
            if ((data === null || data === void 0 ? void 0 : data.retcode) === 0) {
                return {
                    retcode: 0,
                    result: data.result,
                };
            }
            return {
                retcode: (_a = data === null || data === void 0 ? void 0 : data.retcode) !== null && _a !== void 0 ? _a : invalidRetCode,
                msg: "data or data.retcode error ".concat(data === null || data === void 0 ? void 0 : data.retcode),
            };
        }
    });
    return DocumentResourceFetcher;
}());
export { DocumentResourceFetcher };
